module.exports = __webpack_public_path__ + "img/fraunhofer.fc02dd4a.png";